import { useEffect, useState } from "react";

/**
 * Sekunden seit `startedAt` (ms-Timestamp), tickt im 1-s-Takt. `null` → 0,
 * Timer aus. Wird vom CallWidget (laufender Anruf) und von der ActiveCallBar
 * (minimiert) geteilt, damit beide denselben Zeitstand zeigen.
 */
export function useElapsed(startedAt: number | null): number {
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        if (startedAt == null) return;
        setNow(Date.now());
        const t = window.setInterval(() => setNow(Date.now()), 1000);
        return () => window.clearInterval(t);
    }, [startedAt]);
    if (startedAt == null) return 0;
    return Math.max(0, Math.floor((now - startedAt) / 1000));
}

/** Sekunden → "mm:ss" (Stunden werden in Minuten weitergezählt). */
export function fmtMMSS(totalSec: number): string {
    const m = Math.floor(totalSec / 60);
    const s = totalSec % 60;
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}
